import { render, staticRenderFns } from "./LowHighRiskPresenter.vue?vue&type=template&id=67d20a0c"
import script from "./LowHighRiskPresenter.vue?vue&type=script&lang=js"
export * from "./LowHighRiskPresenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports